import variables from '../../../variables';
import {$dom} from '../../../helpers/dom';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

const {exist} = $dom;

export default function createServiceStickyButton(
	wrapSelector = '.js-service-button',
	buttonSelector = '.button--accent'
) {

	if (exist(buttonSelector)) {

		const topOffset = variables.dom.header.offsetHeight * 1.5;
		const bottomOffset = variables.dom.footer.offsetHeight;

		ScrollTrigger.matchMedia({
			"(min-width:992px)": function() {
				ScrollTrigger.create({
					trigger: buttonSelector,
					start: `top-=${topOffset} top`,
					end: `+=${$dom.get(variables.selectors.pageWrapper).offsetHeight - (topOffset + bottomOffset)}`,
					pin: `${wrapSelector} ${buttonSelector}`,
					pinSpacing: false
				});
			}
		});

	}

}
